import { SPOT_PURCHASES_CRUD_ACTION_CREATORS } from '../actions/spot_purchases_actions';
import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';

export const spotPurchasesRestCrudThunksForSupplier = new RestCrudThunks(
	'spot_purchases',
	'spot_purchase',
	'spotPurchase',
	'spotPurchases',
	SPOT_PURCHASES_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'work_order/'
);

export const spotPurchasesRestCrudThunksForBuyer = new RestCrudThunks(
	'spot_purchases',
	'spot_purchase',
	'spotPurchase',
	'spotPurchases',
	SPOT_PURCHASES_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	'work_order/'
);

// Spot purchases are rendered by the same components on both sides of the app, so the
// role has to be selected at dispatch time. Call this with the calling file's role
// (ROLE_TYPES.BUYER / ROLE_TYPES.SUPPLIER) rather than reaching for a hardcoded export.
export const spotPurchasesRestCrudThunks = (roleType: string) =>
	roleType === ROLE_TYPES.SUPPLIER
		? spotPurchasesRestCrudThunksForSupplier
		: spotPurchasesRestCrudThunksForBuyer;
